    // (() => {
    //   const root = document.querySelector('[data-build-a-kit]');
    //   if (!root || root.dataset.initialized === 'true') return;
    //   root.dataset.initialized = 'true';

    //   const subtotalEl = root.querySelector('#build-a-kit-price');
    //   const requiredNote = root.querySelector('[data-bak-required-note]');
    //   const debugPrefix = '[Build-a-Kit]';
     
    //   const moneyFormatter = new Intl.NumberFormat('en-US', {
    //     style: 'currency',
    //     currency: 'USD'
    //   });

    //   function formatAddOnMoney(amount) {
    //     const formatted = moneyFormatter.format(amount);
    //     return amount > 0 ? `+ ${formatted}` : formatted;
    //   }

    //   console.log(debugPrefix, 'Initialized build-a-kit options', {
    //     groups: root.querySelectorAll('[data-bak-group]').length
    //   });

    //   function getCheckedWithValue(group) {
    //     return Array.from(group.querySelectorAll('.opt-btn:checked')).filter((input) => input.value);
    //   }

    //   function getCheckedInputs(group) {
    //     return Array.from(group.querySelectorAll('.opt-btn:checked'));
    //   }

    //   function updateGroup(group) {
    //     const selectionBox = group.querySelector('.bak-selection');
    //     const groupPrice = group.querySelector('.bak-group-price');
    //     const checkedInputs = getCheckedInputs(group);
    //     const checked = checkedInputs.filter((input) => input.value);
    //     const mode = group.dataset.inputMode;
    //     const total = checked.reduce((sum, input) => sum + ((parseFloat(input.dataset.price) || 0) / 100), 0);

    //     if (selectionBox) {
    //       if (checkedInputs.length === 0) {
    //         selectionBox.textContent = group.dataset.required === 'true' ? 'Select an option' : 'None';
    //       } else if (mode === 'checkbox') {
    //         selectionBox.textContent = checked.length === 1 ? checked[0].dataset.label : `${checked.length} items selected`;
    //       } else {
    //         selectionBox.textContent = checkedInputs[0].dataset.label || 'Selected';
    //       }
    //     }

    //     if (groupPrice) groupPrice.textContent = formatAddOnMoney(total);

    //     console.log(debugPrefix, 'Group updated', {
    //       group: group.id,
    //       mode,
    //       selectedCount: checked.length,
    //       selectedLabels: checked.map((input) => input.dataset.label),
    //       groupTotal: formatAddOnMoney(total)
    //     });
    //   }

    //   function updateSubtotal() {
    //     if (!subtotalEl) return;
    //     const basePrice = (parseFloat(subtotalEl.dataset.mainPrice) || 0) / 100;
    //     const additionalPrice = Array.from(root.querySelectorAll('.addon-item .opt-btn:checked')).reduce((sum, input) => {
    //       if (!input.value) return sum;
    //       return sum + ((parseFloat(input.dataset.price) || 0) / 100);
    //     }, 0);

    //     subtotalEl.textContent = moneyFormatter.format(basePrice + additionalPrice);
    //     console.log(debugPrefix, 'Subtotal updated', {
    //       basePrice: moneyFormatter.format(basePrice),
    //       addOnTotal: moneyFormatter.format(additionalPrice),
    //       finalTotal: subtotalEl.textContent
    //     });
    //   }

    //   function validateRequiredGroups() {
    //     const missingGroups = Array.from(root.querySelectorAll('[data-bak-group][data-required="true"]')).filter((group) => {
    //       return getCheckedInputs(group).length === 0;
    //     });

    //     root.classList.toggle('build-a-kit--missing-required', missingGroups.length > 0);
    //     if (requiredNote) requiredNote.hidden = missingGroups.length === 0;

        

    //     console.log(debugPrefix, 'Required group validation', {
    //       valid: missingGroups.length === 0,
    //       missingGroups: missingGroups.map((group) => group.id)
    //     });
    //     return missingGroups;
    //   }

    //   function refreshAll() {
    //     root.querySelectorAll('[data-bak-group]').forEach(updateGroup);
    //     updateSubtotal();
    //     validateRequiredGroups();
    //   }

    //   root.querySelectorAll('.bak-selections .opt-btn').forEach((input) => {
    //     input.addEventListener('change', () => {
    //       console.log(debugPrefix, 'Option changed', {
    //         id: input.id,
    //         type: input.type,
    //         checked: input.checked,
    //         variantId: input.value || null,
    //         label: input.dataset.label,
    //         price: input.dataset.price
    //       });
    //       refreshAll();
    //     });
    //   });

    //   root.querySelectorAll('[data-bak-modal-open]').forEach((button) => {
    //     button.addEventListener('click', (event) => {
    //       event.preventDefault();
    //       event.stopPropagation();
    //       const modal = document.getElementById(button.dataset.bakModalOpen);
    //       if (!modal) return;
    //       if (modal.parentElement !== document.body) {
    //         document.body.appendChild(modal);
    //       }
    //       modal.hidden = false;
    //       document.documentElement.classList.add('bak-modal-open');
    //       document.body.classList.add('bak-modal-open');
    //       console.log(debugPrefix, 'Details panel opened', {
    //         modalId: modal.id
    //       });
    //     });
    //   });

    //   root.querySelectorAll('[data-bak-select]').forEach((button) => {
    //     button.addEventListener('click', () => {
    //       const input = root.querySelector(`#bak-option-${button.dataset.bakSelect}`);
    //       if (!input || input.disabled) return;
    //       input.checked = true;
    //       console.log(debugPrefix, 'Include product clicked from details panel', {
    //         inputId: input.id,
    //         variantId: input.value,
    //         label: input.dataset.label
    //       });
    //       input.dispatchEvent(new Event('change', { bubbles: true }));
    //     });
    //   });

    //   root.querySelectorAll('[data-bak-modal-close]').forEach((button) => {
    //     button.addEventListener('click', () => {
    //       const modal = button.closest('.bak-modal');
    //       if (!modal) return;
    //       modal.hidden = true;
    //       document.documentElement.classList.remove('bak-modal-open');
    //       document.body.classList.remove('bak-modal-open');
    //       console.log(debugPrefix, 'Details panel closed', {
    //         modalId: modal.id
    //       });
    //     });
    //   });

    //   document.addEventListener('keydown', (event) => {
    //     if (event.key !== 'Escape') return;
    //     document.querySelectorAll('.bak-modal:not([hidden])').forEach((modal) => {
    //       modal.hidden = true;
    //       console.log(debugPrefix, 'Details panel closed by Escape', {
    //         modalId: modal.id
    //       });
    //     });
    //     document.documentElement.classList.remove('bak-modal-open');
    //     document.body.classList.remove('bak-modal-open');
    //   });

    //   document.addEventListener('build-a-kit:validate', (event) => {
    //     event.detail.missingGroups = validateRequiredGroups();
    //     console.log(debugPrefix, 'Validation event response', {
    //       missingGroups: event.detail.missingGroups.map((group) => group.id)
    //     });
    //   });

      

    //   refreshAll();
    // })();


    (() => {
  const root = document.querySelector('[data-build-a-kit]');
  if (!root || root.dataset.initialized === 'true') return;
  root.dataset.initialized = 'true';

  const subtotalEl = root.querySelector('#build-a-kit-price');
  const requiredNote = root.querySelector('[data-bak-required-note]');
  const debugPrefix = '[Build-a-Kit]';

  const productForm = root.closest('form');
  const submitButton = productForm
    ? productForm.querySelector('[type="submit"], [name="add"]')
    : document.querySelector('form[action*="/cart/add"] [type="submit"], form[action*="/cart/add"] [name="add"]');

  if (!productForm) {
    console.warn(debugPrefix, 'No enclosing <form> found — falling back to button-only enforcement.');
  }
  if (!submitButton) {
    console.warn(debugPrefix, 'No Add to Cart button found — required-group validation cannot block Add to Cart. Please confirm the correct selector with your developer.');
  }

  const moneyFormatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD'
  });

  function formatAddOnMoney(amount) {
    const formatted = moneyFormatter.format(amount);
    return amount > 0 ? `+ ${formatted}` : formatted;
  }

  console.log(debugPrefix, 'Initialized build-a-kit options', {
    groups: root.querySelectorAll('[data-bak-group]').length
  });

  function getCheckedInputs(group) {
    return Array.from(group.querySelectorAll('.opt-btn:checked'));
  }

  function updateGroup(group) {
    const selectionBox = group.querySelector('.bak-selection');
    const groupPrice = group.querySelector('.bak-group-price');
    const checkedInputs = getCheckedInputs(group);
    const checked = checkedInputs.filter((input) => input.value);
    const mode = group.dataset.inputMode;
    const total = checked.reduce((sum, input) => sum + ((parseFloat(input.dataset.price) || 0) / 100), 0);

    if (selectionBox) {
      if (checkedInputs.length === 0) {
        selectionBox.textContent = group.dataset.required === 'true' ? 'Select an option' : 'None';
      } else if (mode === 'checkbox') {
        selectionBox.textContent = checked.length === 1 ? checked[0].dataset.label : `${checked.length} items selected`;
      } else {
        selectionBox.textContent = checkedInputs[0].dataset.label || 'Selected';
      }
    }

    if (groupPrice) groupPrice.textContent = formatAddOnMoney(total);

    console.log(debugPrefix, 'Group updated', {
      group: group.id,
      mode,
      selectedCount: checked.length,
      selectedLabels: checked.map((input) => input.dataset.label),
      groupTotal: formatAddOnMoney(total)
    });
  }

  function updateSubtotal() {
    if (!subtotalEl) return;
    const basePrice = (parseFloat(subtotalEl.dataset.mainPrice) || 0) / 100;
    const additionalPrice = Array.from(root.querySelectorAll('.addon-item .opt-btn:checked')).reduce((sum, input) => {
      if (!input.value) return sum;
      return sum + ((parseFloat(input.dataset.price) || 0) / 100);
    }, 0);

    subtotalEl.textContent = moneyFormatter.format(basePrice + additionalPrice);
    console.log(debugPrefix, 'Subtotal updated', {
      basePrice: moneyFormatter.format(basePrice),
      addOnTotal: moneyFormatter.format(additionalPrice),
      finalTotal: subtotalEl.textContent
    });
  }

  function setAddToCartBlocked(blocked) {
    if (!submitButton) return;
    if (blocked) {
      submitButton.disabled = true;
      submitButton.setAttribute('aria-disabled', 'true');
      submitButton.dataset.bakDisabled = 'true';
    } else if (submitButton.dataset.bakDisabled === 'true') {
      submitButton.disabled = false;
      submitButton.removeAttribute('aria-disabled');
      delete submitButton.dataset.bakDisabled;
    }
  }

  function validateRequiredGroups() {
    const missingGroups = Array.from(root.querySelectorAll('[data-bak-group][data-required="true"]')).filter((group) => {
      return getCheckedInputs(group).length === 0;
    });

    root.classList.toggle('build-a-kit--missing-required', missingGroups.length > 0);
    if (requiredNote) requiredNote.hidden = missingGroups.length === 0;
    setAddToCartBlocked(missingGroups.length > 0);

    console.log(debugPrefix, 'Required group validation', {
      valid: missingGroups.length === 0,
      missingGroups: missingGroups.map((group) => group.id)
    });
    return missingGroups;
  }

  function refreshAll() {
    root.querySelectorAll('[data-bak-group]').forEach(updateGroup);
    updateSubtotal();
    validateRequiredGroups();
  }

  root.querySelectorAll('.bak-selections .opt-btn').forEach((input) => {
    input.addEventListener('change', () => {
      console.log(debugPrefix, 'Option changed', {
        id: input.id,
        type: input.type,
        checked: input.checked,
        variantId: input.value || null,
        label: input.dataset.label,
        price: input.dataset.price
      });
      refreshAll();
    });
  });

  root.querySelectorAll('[data-bak-modal-open]').forEach((button) => {
    button.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      const modal = document.getElementById(button.dataset.bakModalOpen);
      if (!modal) return;
      if (modal.parentElement !== document.body) {
        document.body.appendChild(modal);
      }
      modal.hidden = false;
      document.documentElement.classList.add('bak-modal-open');
      document.body.classList.add('bak-modal-open');
      console.log(debugPrefix, 'Details panel opened', {
        modalId: modal.id
      });
    });
  });

  root.querySelectorAll('[data-bak-select]').forEach((button) => {
    button.addEventListener('click', () => {
      const input = root.querySelector(`#bak-option-${button.dataset.bakSelect}`);
      if (!input || input.disabled) return;
      input.checked = true;
      console.log(debugPrefix, 'Include product clicked from details panel', {
        inputId: input.id,
        variantId: input.value,
        label: input.dataset.label
      });
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });

  root.querySelectorAll('[data-bak-modal-close]').forEach((button) => {
    button.addEventListener('click', () => {
      const modal = button.closest('.bak-modal');
      if (!modal) return;
      modal.hidden = true;
      document.documentElement.classList.remove('bak-modal-open');
      document.body.classList.remove('bak-modal-open');
      console.log(debugPrefix, 'Details panel closed', {
        modalId: modal.id
      });
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.bak-modal:not([hidden])').forEach((modal) => {
      modal.hidden = true;
      console.log(debugPrefix, 'Details panel closed by Escape', {
        modalId: modal.id
      });
    });
    document.documentElement.classList.remove('bak-modal-open');
    document.body.classList.remove('bak-modal-open');
  });

  document.addEventListener('build-a-kit:validate', (event) => {
    event.detail.missingGroups = validateRequiredGroups();
    console.log(debugPrefix, 'Validation event response', {
      missingGroups: event.detail.missingGroups.map((group) => group.id)
    });
  });

  // Hard block: prevents Add to Cart via direct click on the button,
  // even if some other script has re-enabled it. Capture phase ensures
  // this runs before any AJAX add-to-cart handler on the same button.
  if (submitButton) {
    submitButton.addEventListener('click', (event) => {
      const missingGroups = validateRequiredGroups();
      if (missingGroups.length > 0) {
        event.preventDefault();
        event.stopImmediatePropagation();
        missingGroups[0].scrollIntoView({ behavior: 'smooth', block: 'center' });
        console.log(debugPrefix, 'Add to cart click blocked — required selections missing', {
          missingGroups: missingGroups.map((group) => group.id)
        });
      }
    }, true);
  }

  // Fallback: blocks native form submission (e.g. Enter key) as well.
  if (productForm) {
    productForm.addEventListener('submit', (event) => {
      const missingGroups = validateRequiredGroups();
      if (missingGroups.length > 0) {
        event.preventDefault();
        event.stopImmediatePropagation();
        missingGroups[0].scrollIntoView({ behavior: 'smooth', block: 'center' });
        console.log(debugPrefix, 'Add to cart submit blocked — required selections missing', {
          missingGroups: missingGroups.map((group) => group.id)
        });
      }
    }, true);
  }

  refreshAll();
})();